import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";

const URL = "https://www.mostrandomexico.mx/privacidad";

export const Route = createFileRoute("/privacidad")({
  head: () => ({
    meta: [
      { title: "Política de Privacidad — Mostrando México" },
      {
        name: "description",
        content:
          "Cómo Mostrando México recopila, usa y protege tus datos personales en cumplimiento con la LFPDPPP.",
      },
      { property: "og:title", content: "Política de Privacidad — Mostrando México" },
      { property: "og:description", content: "Aviso de privacidad integral." },
      { property: "og:url", content: URL },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: PrivacidadPage,
});

function PrivacidadPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="font-display text-4xl font-semibold">Política de Privacidad</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Aviso de privacidad integral · junio 2026
        </p>

        <div className="prose prose-neutral mt-8 max-w-none text-foreground/85">
          <h2>1. Responsable del tratamiento</h2>
          <p>
            <strong>Company Mostrando Mexico</strong> ("Mostrando México"), con domicilio en
            Boulevard Kukulcán, Hotel Zone Km 9, Cancún, Q.R., México, es responsable del
            tratamiento de tus datos personales conforme a la Ley Federal de Protección de
            Datos Personales en Posesión de los Particulares (LFPDPPP).
          </p>

          <h2>2. Datos que recopilamos</h2>
          <ul>
            <li>Identificación: nombre, fecha de nacimiento, nacionalidad.</li>
            <li>Contacto: correo electrónico, teléfono, país.</li>
            <li>Pago: procesado por Stripe / Mercado Pago — nunca almacenamos tu tarjeta.</li>
            <li>Datos de navegación: cookies, IP, idioma, tipo de dispositivo.</li>
          </ul>

          <h2>3. Finalidades</h2>
          <p>Usamos tus datos para:</p>
          <ul>
            <li>Procesar reservas, pagos, vouchers y confirmaciones.</li>
            <li>Atención al cliente y soporte postventa.</li>
            <li>Comunicaciones operativas y, con tu consentimiento, marketing.</li>
            <li>Mejorar la experiencia del sitio mediante analítica anónima.</li>
          </ul>

          <h2>4. Transferencias</h2>
          <p>
            Compartimos tus datos exclusivamente con proveedores necesarios para entregar el
            servicio: operadores de tours, plataformas de reservas (Bokun), procesadores de
            pago (Stripe, Mercado Pago) y aerolíneas. Todos están obligados contractualmente a
            proteger tus datos.
          </p>

          <h2>5. Cookies</h2>
          <p>
            Usamos cookies técnicas y de analítica para mantener tu sesión, recordar idioma y
            medir desempeño. Puedes desactivarlas desde tu navegador, aunque algunas funciones
            podrían dejar de operar correctamente.
          </p>

          <h2>6. Derechos ARCO</h2>
          <p>
            Tienes derecho a Acceder, Rectificar, Cancelar u Oponerte al tratamiento de tus
            datos. Para ejercerlos escríbenos a{" "}
            <a href="mailto:info@mostrandomexico.mx" className="text-primary">
              info@mostrandomexico.mx
            </a>{" "}
            indicando tu nombre completo, copia de identificación y la solicitud específica.
          </p>

          <h2>7. Conservación</h2>
          <p>
            Conservamos tus datos durante el tiempo necesario para cumplir con las finalidades
            y obligaciones legales aplicables (mínimo 5 años para registros fiscales).
          </p>

          <h2>8. Seguridad</h2>
          <p>
            Aplicamos medidas técnicas, físicas y administrativas razonables para proteger tus
            datos contra acceso no autorizado, pérdida o alteración. Toda comunicación con el
            sitio se realiza por HTTPS.
          </p>

          <h2>9. Cambios al aviso</h2>
          <p>
            Cualquier modificación se publicará en esta página con la nueva fecha de
            actualización.
          </p>

          <h2>10. Contacto</h2>
          <p>
            <a href="mailto:info@mostrandomexico.mx" className="text-primary">info@mostrandomexico.mx</a>{" "}
            · WhatsApp{" "}
            <a href="https://wa.me/529983381476" className="text-primary">+52 998 338 1476</a>
          </p>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
